import { useEffect } from "react";

export const ConsultationPage = () => {
  useEffect(() => {
    // Dynamically load GHL form script to ensure clean initialization
    const existing = document.getElementById("ghl-form-script");
    if (!existing) {
      const script = document.createElement("script");
      script.id = "ghl-form-script";
      script.src = "https://link.msgsndr.com/js/form_embed.js";
      script.type = "text/javascript";
      document.body.appendChild(script);
    }
  }, []);

  return (
    <main data-testid="consultation-page">
      {/* PAGE HERO */}
      <div className="pg-page-hero">
        <div className="pg-container">
          <span className="pg-label">Start Your Journey</span>
          <h1>Schedule Your Paradigm Global Business Strategy Session</h1>
          <p>Complete the brief consultation form below so our team can better understand your financial goals and business objectives before your strategy session.</p>
        </div>
      </div>

      {/* FORM SECTION */}
      <section className="pg-section">
        <div className="pg-container">
          <div style={{
            maxWidth: 720, margin: "0 auto", background: "#fff", borderRadius: 20,
            boxShadow: "0 12px 40px rgba(0,0,0,.08)", padding: "2rem"
          }}>
            <iframe
              src="https://api.leadconnectorhq.com/widget/form/KqYCcbVfB0B0W25OjXCr"
              style={{ width: "100%", minHeight: "800px", border: "none", borderRadius: 4 }}
              id="inline-KqYCcbVfB0B0W25OjXCr"
              data-layout="{'id':'INLINE'}"
              data-trigger-type="alwaysShow"
              data-trigger-value=""
              data-activation-type="alwaysActivated"
              data-activation-value=""
              data-deactivation-type="leadCollected"
              data-deactivation-value=""
              data-form-name="Paradigm Master Form"
              data-height="4259"
              data-layout-iframe-id="inline-KqYCcbVfB0B0W25OjXCr"
              data-form-id="KqYCcbVfB0B0W25OjXCr"
              title="Paradigm Master Form"
              data-testid="ghl-consultation-form"
            />
          </div>

          <div style={{ textAlign: "center", marginTop: "1.5rem" }}>
            <p style={{ color: "var(--muted)", fontSize: ".85rem" }}>
              <i className="fas fa-lock" style={{ color: "var(--magenta)", marginRight: ".4rem" }} />
              Your information is 100% secure and will never be shared.
            </p>
          </div>
        </div>
      </section>

      {/* WHAT TO EXPECT */}
      <section className="pg-section pg-section-light">
        <div className="pg-container">
          <div className="pg-text-center">
            <span className="pg-label">What to Expect</span>
            <h2>Your Consultation Journey</h2>
            <div className="pg-divider" />
          </div>
          <div className="pg-steps-grid">
            {[
              { num: "01", icon: "fa-file-alt", title: "Complete the Form", desc: "Share your business details and goals so we can prepare for your session." },
              { num: "02", icon: "fa-calendar-check", title: "Choose Your Time", desc: "After submitting, select a convenient time for your strategy session." },
              { num: "03", icon: "fa-user-tie", title: "Meet Your Advisor", desc: "Connect with a Paradigm strategy professional for personalized guidance." },
              { num: "04", icon: "fa-rocket", title: "Take Action", desc: "Receive a customized roadmap with actionable next steps for growth." },
            ].map((s) => (
              <div key={s.title} style={{ textAlign: "center", padding: "1.5rem" }}>
                <div style={{
                  width: 60, height: 60, borderRadius: "50%", background: "var(--bg-pink)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  margin: "0 auto .8rem", color: "var(--magenta)", fontSize: "1.2rem"
                }}>
                  <i className={`fas ${s.icon}`} />
                </div>
                <div style={{
                  fontFamily: "'Playfair Display', serif", fontSize: "1.8rem",
                  background: "var(--grad)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
                  backgroundClip: "text", fontWeight: 700, marginBottom: ".4rem"
                }}>
                  {s.num}
                </div>
                <h4 style={{ color: "var(--black)", marginBottom: ".3rem", fontSize: ".95rem" }}>{s.title}</h4>
                <p style={{ color: "var(--muted)", fontSize: ".85rem", margin: 0 }}>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CONTACT ALT */}
      <section className="pg-cta-banner">
        <div className="pg-container">
          <h2>Prefer to Reach Out Directly?</h2>
          <p>Our team is ready to assist you with any questions.</p>
          <div className="pg-cta-btns">
            <a href="tel:+18635851412" className="pg-btn pg-btn-white">
              <i className="fas fa-phone" /> (863) 585-1412
            </a>
            <a href="mailto:info@financialfreedomdelivered.com" className="pg-btn pg-btn-outline-white">
              <i className="fas fa-envelope" /> Email Us
            </a>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ConsultationPage;
